import React from "react"
import { Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import NumericCard from "./numeric-card"
import TaskCard from "./task-card"
import CustomTooltip from "../../ui-components/custom-tooltip"
import useASTStore from "src/v2/utils/AST-store"

const useStyles = makeStyles((theme) => ({
  stickyHeader: {
    fontSize: 24,
    marginTop: 24,
    background: "#f5f5f5",
    boxShadow: "rgba(0, 0, 0, 0.25) 4px 4px 4px 0px",
    borderRadius: 11,
    padding: "5px 24px 5px 16px",
    position: "sticky",
    top: 64, // <-- Adjust this value to match your app's header height
    zIndex: 998,
    [theme.breakpoints.down("xs")]: {
      fontSize: 18,
      padding: "5px 12px 5px 8px",
      top: 56, // <-- Adjust for mobile header height if needed
    },
  },
  cardWrapper: {
    marginTop: 24,
    fontSize: 18,
    [theme.breakpoints.down("xs")]: {
      fontSize: 15,
      marginTop: 16,
    },
  },
  cardTitle: {
    fontWeight: 200,
    marginRight: 8,
  },
  cardName: {
    fontWeight: 600,
    wordBreak: "break-all",
  },
}))

export default function TaskCardList() {
  const classes = useStyles()
  const selectedResource = useASTStore((s) => s.selectedResource)

  const showProgressCheckboxFormalMapping =
    window["config"]?.SHOW_PROGRESS_CHECKBOX_FORMAL_MAPPING === "YES"

  if (!selectedResource || !selectedResource.cards) return null

  const cards = selectedResource.cards
  const displayName =
    selectedResource.displayName || selectedResource.name || ""
  const showTooltip = displayName.length > 30
  const displayShort = showTooltip
    ? `${displayName.substring(0, 27)}...`
    : displayName

  // Filter cards based on showProgressCheckboxFormalMapping
  const filteredCards = showProgressCheckboxFormalMapping
    ? cards
    : cards.filter((card) =>
        card.cardElements.some((element) => element.type === "resources" || element.type === "expandable-path-resources"),
      )

  return (
    <Box>
      <Box className={classes.stickyHeader}>
        <span className={classes.cardTitle}>
          Analysis of the {selectedResource.type}
        </span>
        <CustomTooltip title={showTooltip ? displayName : ""}>
          <b className={classes.cardName}>{displayShort}</b>
        </CustomTooltip>
      </Box>
      {filteredCards.map((card, index) => (
        <Box className={classes.cardWrapper} key={index}>
          <NumericCard id={card.id} number={index + 1} title={card.title}>
            {card.cardElements.map((x, idx) => (
              <TaskCard key={idx} cardElement={x} cardId={card.id} />
            ))}
          </NumericCard>
        </Box>
      ))}
    </Box>
  )
}
